module.exports = __webpack_public_path__ + "img/richtext.b6e0ac04.svg";